module.exports = __webpack_public_path__ + "img/resource-tech-image-64.bdeb6ca5.jpg";